import { ChevronRight } from 'lucide-react'
import Dot from '@/components/Dot'
import type { DotTone } from '@/components/Dot'

export type FunnelStep = {
  key: string
  value: number | string
  description: string
  tone: DotTone
}

type Props = {
  steps: FunnelStep[]
}

export default function HarvestFunnel({ steps }: Props) {
  return (
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-3 lg:grid-cols-5">
      {steps.map((s, i) => (
        <div
          key={s.key}
          className="relative rounded-[10px] border border-[var(--border)] bg-[var(--muted)]/30 p-3"
        >
          <div className="text-[10.5px] font-bold uppercase tracking-wider text-[var(--muted-foreground)]">
            {s.key}
          </div>
          <div className="mt-1 flex items-baseline gap-1.5">
            <Dot tone={s.tone} />
            <span className="text-[22px] font-bold tabular-nums text-[var(--foreground)]">
              {typeof s.value === 'number' ? s.value.toLocaleString('de-DE') : s.value}
            </span>
          </div>
          <div className="mt-0.5 text-[11.5px] text-[var(--muted-foreground)]">
            {s.description}
          </div>
          {i < steps.length - 1 && (
            <ChevronRight className="absolute -right-2 top-1/2 hidden h-3.5 w-3.5 -translate-y-1/2 text-[var(--muted-foreground)] lg:block" />
          )}
        </div>
      ))}
    </div>
  )
}
